import { Add } from "@mui/icons-material";
import { FormControl, TextField } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import useCreateOrganizationProposalChecklistItem from "hooks/organization/useCreateOrganizationProposalChecklistItem";
import { useState } from "react";

export default function CreateChecklistItem() {
  const [isAdding, setIsAdding] = useState(false);
  const [name, setName] = useState("");
  const [createChecklistItem, { loading }] = useCreateOrganizationProposalChecklistItem();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (name.trim()) {
      createChecklistItem({
        variables: {
          name: name.trim(),
        },
        onCompleted: () => {
          setName("");
          setIsAdding(false);
        },
      });
    }
  };

  if (!isAdding) {
    return (
      <MDButton
        variant="gradient"
        color="info"
        size="small"
        startIcon={<Add />}
        onClick={() => setIsAdding(true)}
      >
        Add Item
      </MDButton>
    );
  }

  return (
    <MDBox component="form" onSubmit={handleSubmit} width="100%" maxWidth="500px">
      <MDBox display="flex" alignItems="center" mb={1}>
        <MDTypography variant="subtitle2" fontWeight="medium">
          New Checklist Item
        </MDTypography>
      </MDBox>
      <MDBox display="flex" gap={1} alignItems="center">
        <TextField
          label="Item Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
          autoFocus
          size="small"
          sx={{ minWidth: "250px" }}
        />
        <MDButton
          variant="contained"
          color="success"
          type="submit"
          disabled={loading || !name.trim()}
          size="small"
        >
          Save
        </MDButton>
        <MDButton
          variant="outlined"
          color="secondary"
          onClick={() => {
            setIsAdding(false);
            setName("");
          }}
          size="small"
        >
          Cancel
        </MDButton>
      </MDBox>
    </MDBox>
  );
}
